import { render, staticRenderFns } from "./year-range.vue?vue&type=template&id=0a273f22&scoped=true"
import script from "./year-range.vue?vue&type=script&lang=js"
export * from "./year-range.vue?vue&type=script&lang=js"
import style0 from "./year-range.vue?vue&type=style&index=0&id=0a273f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a273f22",
  null
  
)

export default component.exports